import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {RecurringEventSaveTypesEnum} from '../../../../store/data/calendarEventVersions/calendarEventVersionsActions';
import {OkCancelDialog} from '../../../common/dialogs/okCancelDialog';
import {RecurringSaveTypeSelector} from './recurringSaveTypeSelector';

/*
 * Props.
 */

interface RecurringUpdateDialogProps {
  onConfirmClick: HandlerOf<RecurringEventSaveTypesEnum>;
  onCancelClick: Handler;
}

/*
 * Component.
 */

export const RecurringUpdateDialog: FC<RecurringUpdateDialogProps> = (props) => {
  const [recurringSaveType, setRecurringSaveType] = useState(RecurringEventSaveTypesEnum.INSTANCE);

  return (
    <OkCancelDialog
      title={<Trans id="recurring-dialog-update-title">Edit a recurring event</Trans>}
      okButtonLabel={<Trans id="recurring-dialog-update-action">Save</Trans>}
      onOkClick={() => props.onConfirmClick(recurringSaveType)}
      onRequestClose={props.onCancelClick}
    >
      <RecurringSaveTypeSelector recurringSaveType={recurringSaveType} onChange={setRecurringSaveType} />
    </OkCancelDialog>
  );
};
